import { ProgressBar } from "react-bootstrap";
import { CSSProperties, useEffect, useRef, useState } from "react";
// components
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import { ReactComponent as OutlineZipFiles } from "assets/svg/outline-zip-files.svg";
import IconButton from "components/icon-button";
import PasswordEditor from "../password-editor";
// styles
import styles from "./styles.module.scss";
// types
import type { DataTransferUploadTaskState } from "components/Dashboard/DoctorDashboard/views/data-transfer/types";

type Props = {
  value: DataTransferUploadTaskState;
  onAbort: (arg: DataTransferUploadTaskState) => void;
  // TODO: update the type to be the same in the context provider
  onSubmitPassword: () => void;
};
/**
 * renders the stateless UI for viewing uploaded task in modal
 */
const UploadTaskUI = ({ value, onAbort, onSubmitPassword }: Props) => {
  const editorPositionRef = useRef<HTMLDivElement | null>(null);
  const [editorPosition, setEditorPosition] = useState<CSSProperties>({});
  const [showPasswordEditor, setShowPasswordEditor] = useState(false);
  const [showOnce, setShowOnce] = useState(false);

  // show password editor if it needs the password
  useEffect(() => {
    if (showOnce) {
      return;
    }
    if (value.requirePassword && !value.password) {
      if (editorPositionRef.current) {
        const { left, top } = editorPositionRef.current.getBoundingClientRect();

        setEditorPosition({
          left,
          top,
        });
      }
      setShowOnce(true);
      return setShowPasswordEditor(true);
    }
    return setShowPasswordEditor(false);
  }, [showOnce, value.password, value.requirePassword]);

  return (
    <div className={styles["upload-task-ui"]}>
      <div className={styles["upload-task-ui__col"]}>
        <OutlineZipFiles className={styles["upload-task-ui__icon"]} />
      </div>
      <div className={styles["upload-task-ui__col"]}>{value.name}</div>
      <div className={styles["upload-task-ui__col"]} ref={editorPositionRef}>
        <ProgressBar
          className={styles["upload-task-ui__progress-bar"]}
          now={value.percent}
        />
      </div>

      <div className={styles["upload-task-ui__col"]}>
        {(value.percent || 0) + "%"}
      </div>
      <div className={styles["upload-task-ui__col"]}>
        <IconButton onClick={() => onAbort(value)}>
          <OutlineCross className={styles["upload-task-ui__icon"]} />
        </IconButton>
      </div>
      {showPasswordEditor && (
        <PasswordEditor
          value={value}
          // TODO: add onSubmit logic here, it should be inherited from
          onSubmit={onSubmitPassword}
          style={editorPosition}
          onHide={() => setShowPasswordEditor(false)}
        />
      )}
    </div>
  );
};

export default UploadTaskUI;
